module.exports = __webpack_public_path__ + "img/new_sliding_door.2c50a89e.png";